<style lang="css">
@import '../css/bootstrap.css';
@import '../css/bootstrap-vue.css';
@import '../css/admin-table.css';
</style>
<style lang="scss" scoped>
@import '../css/admin.scss';
</style>
<template>
  <div class="admin-page">
    <admin-header :tit="this.title"></admin-header>
    <admin-side></admin-side>
    <section class="admin-template">
      <h2 class="sub-tit">배너 관리</h2>
      <div class="contents">
        <b-container fluid>
          <!-- User Interface controls -->
            <b-row>
             <b-col class="my-1 text-left type-box">
               <b-form-group
                label="배너 Type"
                label-for="form-select"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                class="mb-0 "
              >
               <b-form-select size="sm" class="item-select" id="form-select" v-model="typeSelected" :options="itemOptions"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col class="my-1 filter-box">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    type="search"
                    placeholder="배너명을 검색 해 주세요."
                    v-model="searchText"
                  ></b-form-input>
                  <b-button size="sm" @click="itemFilter()" class="search-btn">검색</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Main table element -->
          <b-table
            id="expert-banner"
            :items="items"
            :fields="fields"
            stacked="md"
            show-empty
            small
          >
            <template #cell(banId)="row">
              {{ row.value }}
            </template>
            <template #cell(banOrd)="row">
              {{ row.value }}
            </template>
            <template #cell(itemNm)="row">
              {{ row.value }}
            </template>
            <template #cell(fileName)="row">
              <div class="thumb-img banner" :class="{'event': row.item.itemNm === '이벤트배너'}">
                <img :src="imgUrl + '/' + row.value">
              </div>
            </template>
            <template #cell(banTitle)="row">
              {{ row.value }}
            </template>
            <template #cell(actions)="row">
              <b-button size="sm" @click="modifyItem(row.item, row.index)" class="save-btn mr-1">수정</b-button>
              <b-button size="sm" @click="deleteItem(row.item, row.index)" class="deleat-btn">삭제</b-button>
            </template>
          </b-table>
           <b-row>
            <b-col lg="12" class="my-1 text-right">
              <b-button variant="primary" @click="newItem()" class="new-item-btn">신규</b-button>
            </b-col>
          </b-row>
          <b-modal
          id="add-banner"
          class="item-modal banner-modal"
          size="lg"
          title="배너 추가하기"
          @show="resetModal"
          @hidden="resetModal"
          >
            <b-row class="modal-top-row">
              <b-col sm="3" class="my-1 top-row-banner">
                <div class="my-1 text-left">
                  <label>배너번호</label>
                  <b-form-input
                    v-model="infoModal.bannerNo"
                    disabled
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="3" class="my-1 top-row-banner">
                <div class="my-1 text-left">
                <label>배너순서</label>
                <b-form-input
                  v-model="infoModal.bannerOrd"
                ></b-form-input>
              </div>
              </b-col>
              <b-col sm="3" class="my-1 top-row-banner">
                <div class="my-1">
                  <label>배너타입</label>
                  <b-form-select size="sm" class="item-select" id="form-select-city" v-model="infoModal.typeSelected" :options="infoModal.type"></b-form-select>
                </div>
              </b-col>
              <b-col sm="3" class="my-1 top-row-banner">
                <div class="my-1">
                  <label>배너새창여부</label>
                  <b-form-select size="sm" class="item-select" id="form-select-city" v-model="infoModal.viewSelected" :options="infoModal.viewType"></b-form-select>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>배너제목</label>
                  <b-form-input
                    v-model="infoModal.bannerTitle"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>배너상세</label>
                  <b-form-input
                    v-model="infoModal.bannerDesc"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>배너연결 URL</label>
                  <b-form-input
                    v-model="infoModal.bannerUrl"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-third-row">
              <b-col sm="12" class="my-1 modal-third-area">
                <label>배너이미지</label>
                <div class="my-1 text-left desc search">
                  <VueFileAgent
                  ref="vueFileAgent"
                  :theme="'list'"
                  :multiple="false"
                  :deletable="true"
                  :meta="true"
                  :accept="'image/*'"
                  :maxSize="'10MB'"
                  :maxFiles="1"
                  :helpText="'첨부할 사진을 마우스로 끌어서 추가할 수 있습니다.'"
                  :errorText="{
                    type: '이미지만 업로드가 가능합니다.',
                    size: '사진크기는 10MB 를 넘을 수 없습니다.',
                  }"
                  @select="filesSelected($event)"
                  @beforedelete="onBeforeDelete($event)"
                  @delete="fileDeleted($event)"
                  v-model="fileRecords"
                  ></VueFileAgent>
                  <p class="color-red" v-if="infoModal.typeSelected === '001'">이벤트 배너 사이즈는 가로 320px 세로 410px 입니다.</p>
                  <p class="color-red" v-else>하단 배너 사이즈는 가로 120px 세로 26px 입니다.</p>
                  <div class="text-right save-btn-area">
                    <b-button
                    variant="primary"
                    class="default-btn address-search btn-primary"
                    @click="modalAdd()"
                  >
                    저장
                  </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
            <template #modal-footer>
              <b-row class="modify-footer">
              </b-row>
            </template>
          </b-modal>
          <b-modal id="modify-banner"
          size="lg"
          class="item-modal banner-modal"
          @show="resetModal"
          @hidden="resetModal"
          :title="infoModal.title" ok-only>
            <b-row class="modal-top-row">
              <b-col sm="3" class="my-1 top-row-banner">
                <div class="my-1 text-left">
                  <label>배너번호</label>
                  <b-form-input
                    v-model="infoModal.bannerNo"
                    disabled
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="3" class="my-1 top-row-banner">
                <div class="my-1 text-left">
                <label>배너순서</label>
                <b-form-input
                  v-model="infoModal.bannerOrd"
                ></b-form-input>
              </div>
              </b-col>
              <b-col sm="3" class="my-1 top-row-banner">
                <div class="my-1">
                  <label>배너타입</label>
                  <b-form-select size="sm" class="item-select" id="form-select-city" v-model="infoModal.typeSelected" :options="infoModal.type"></b-form-select>
                </div>
              </b-col>
              <b-col sm="3" class="my-1 top-row-banner">
                <div class="my-1">
                  <label>배너새창여부</label>
                  <b-form-select size="sm" class="item-select" id="form-select-city" v-model="infoModal.viewSelected" :options="infoModal.viewType"></b-form-select>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>배너제목</label>
                  <b-form-input
                    v-model="infoModal.bannerTitle"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>배너상세</label>
                  <b-form-input
                    v-model="infoModal.bannerDesc"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>배너연결 URL</label>
                  <b-form-input
                    v-model="infoModal.bannerUrl"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-third-row">
              <b-col sm="12" class="my-1 modal-third-area">
                <div class="my-1 text-left desc search">
                  <label>대표사진</label>
                  <VueFileAgent
                  ref="vueFileAgent"
                  :theme="'list'"
                  :multiple="false"
                  :deletable="true"
                  :meta="true"
                  :accept="'image/*'"
                  :maxSize="'10MB'"
                  :maxFiles="1"
                  :helpText="'첨부할 사진을 마우스로 끌어서 추가할 수 있습니다.'"
                  :errorText="{
                    type: '이미지만 업로드가 가능합니다.',
                    size: '사진크기는 10MB 를 넘을 수 없습니다.',
                  }"
                  @select="filesSelected($event)"
                  @beforedelete="onBeforeDelete($event)"
                  @delete="fileDeleted($event)"
                  v-model="fileRecords"
                  ></VueFileAgent>
                  <p class="color-red" v-if="infoModal.typeSelected === '001'">이벤트 배너 사이즈는 가로 320px 세로 410px 입니다.</p>
                  <p class="color-red" v-else>하단 배너 사이즈는 가로 90px 세로 20px 입니다.</p>
                  <div class="text-right save-btn-area">
                    <b-button
                    variant="primary"
                    class="default-btn address-search btn-primary"
                    @click="modifySave()"
                  >
                    저장
                  </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
            <template #modal-footer>
              <b-row class="modify-footer">
              </b-row>
            </template>
          </b-modal>
        </b-container>
      </div>
    </section>
  </div>
</template>
<script>
import AdminHeader from '@/components/AdminHeader'
import AdminSide from '@/components/AdminSide'
import DaumPostcode from '@/components/DaumPostcode'

import { mapGetters } from 'vuex'

export default {
  name: 'AdminBanner',
  components: {
    'admin-header': AdminHeader,
    'admin-side': AdminSide,
    'vuejs-address': DaumPostcode
  },
  data () {
    return {
      title: '관리자 페이지',
      layerPopPost: false,
      searchText: '',
      typeSelected: '',
      itemOptions: [
        { value: '', text: '전체' }
      ],
      selected: [],
      addFileRecords: [],
      modifyFileRecords: [],
      fileRecordsForUpload: [],
      fileRecordsForDelete: [],
      fileRecords: [
        /* {
          name: 'img_start.png',
          url: 'http://127.0.0.1:8081/uploads/pro_images/7/img_start.png',
          lastModified: '',
          size: '10000',
          type: 'image/png',
          ext: 'png',
        } */
      ],
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent' },
      imgUrl: this.$store.state.common.urlpath,
      uploadUrl: this.$store.state.common.urlpath + '/api/fileupload/process',
      // uploadUrl: 'http://127.0.0.1:8081' + '/api/fileupload/process',
      /* items: [
        {
          bannerNum: '1',
          bannerOrther: '1',
          bannerType: '이벤트배너',
          bannerthumb: require('../img/main/right-banner-01.jpg'),
          bannerTit: '이벤트 배너 1번'
        },
        {
          bannerNum: '2',
          bannerOrther: '2',
          bannerType: '하단배너',
          bannerthumb: require('../img/main/bank-ibk.png'),
          bannerTit: '이벤트 배너 2번'
        }
      ], */
      fields: [
        { key: 'banId', label: '배너번호', class: 'text-center' },
        { key: 'banOrd', label: '배너순서', class: 'text-center' },
        { key: 'itemNm', label: '배너타입', class: 'text-center' },
        { key: 'fileName', label: '배너사진', class: 'text-center' },
        { key: 'banTitle', label: '배너제목', class: 'text-center' },
        { key: 'actions', label: '', class: 'text-center' }
      ],
      totalRows: 1,
      infoModal: {
        id: 'info-modal',
        title: '배너 추천',
        thumb: require('../img/main/thumb-img.png'),
        bannerNo: '신규',
        bannerOrd: '1',
        bannerTitle: '배너 제목입니다.',
        bannerDesc: '',
        typeSelected: '',
        type: [
          /* { value: '0', text: '무료' },
          { value: '1', text: '유료' } */
        ],
        bannerUrl: 'http://www.naver.com',
        viewSelected: '',
        viewType: []
      }
    }
  },
  created () {
    this.initBannerCode()
  },
  watch: {
    typeBanner () {
      this.infoModal.type = []
      for (var i = 0; i < this.typeBanner.length; i++) {
        // console.log(this.typeNotices[i])
        let tmp = { value: this.typeBanner[i].deCode, text: this.typeBanner[i].codeNm }
        this.itemOptions.push(tmp)
        this.infoModal.type.push(tmp)
      }
      this.typeSelected = this.itemOptions[0].value
      this.infoModal.typeSelected = this.infoModal.type[0].value
      this.getBannerList()
    },
    typeViewFrame () {
      this.infoModal.viewType = []
      for (var i = 0; i < this.typeViewFrame.length; i++) {
        // console.log(this.typeNotices[i])
        let tmp = { value: this.typeViewFrame[i].deCode, text: this.typeViewFrame[i].codeNm }
        this.infoModal.viewType.push(tmp)
      }
      this.infoModal.viewSelected = this.infoModal.viewType[0].value
    }
  },
  methods: {
    initBannerCode: function () {
      this.$store.dispatch('apiEtcCodelists', {'Code': '006', 'DeCode': ''})
      this.$store.dispatch('apiEtcCodelists', {'Code': '007', 'DeCode': ''})
    },
    getBannerList () {
      this.$store.dispatch('apiBannerList', {'banCd': this.typeSelected, 'banTitle': this.searchText})
    },
    showModal: function () {
      this.layerPopPost = true
    },
    newItem () {
      this.infoModal.title = '배너 추가하기'
      this.infoModal.bannerNo = '신규'
      this.infoModal.bannerOrd = ''
      this.infoModal.bannerTitle = ''
      this.infoModal.bannerDesc = ''
      this.infoModal.bannerUrl = ''
      this.infoModal.typeSelected = this.infoModal.type[0].value
      this.infoModal.viewSelected = this.infoModal.viewType[0].value
      this.fileRecords = []
      this.fileRecordsForUpload = []
      this.fileRecordsForDelete = []
      this.$root.$emit('bv::show::modal', 'add-banner')
    },
    modifyItem (item, index) {
      this.infoModal.title = '배너 수정하기'
      this.infoModal.bannerNo = item.banId
      this.infoModal.bannerOrd = item.banOrd
      this.infoModal.bannerTitle = item.banTitle
      this.infoModal.bannerDesc = item.banDesc
      this.infoModal.bannerUrl = item.banUrl
      this.infoModal.typeSelected = item.itemCd
      this.infoModal.viewSelected = item.banView
      let info = this.getFileInfo(item)
      this.fileRecords = info
      this.fileRecordsForUpload = info
      this.fileRecordsForDelete = []
      this.$root.$emit('bv::show::modal', 'modify-banner')
    },
    saveBanner (type, obj) {
      const params = {
        'banTitle': obj.bannerTitle,
        'banDesc': obj.bannerDesc,
        'banUrl': obj.bannerUrl,
        'banOrd': obj.bannerOrd,
        'banId': (obj.bannerNo === '신규' ? '' : obj.bannerNo),
        'banCd': obj.typeSelected,
        'banView': obj.viewSelected,
        'flag': type
      }
      // console.log('param = ' + params)
      this.$store.dispatch('apiTranBanner', params).then(() => {
        // console.log('this.tranBannerRtn = ' + this.tranBannerRtn)
        if (this.tranBannerRtn !== 'fail') {
          if (type === 'I') {
            this.uploadFiles()
            this.$nextTick(() => {
              this.$bvModal.hide('add-banner')
            })
          } else if (type === 'U') {
            if (this.fileRecordsForDelete.length > 0) {
              this.deleteUploadedFile()
            } else {
              this.uploadFiles()
            }
            this.$nextTick(() => {
              this.$bvModal.hide('modify-banner')
            })
          } else {
            // alert('삭제')
            if (this.fileRecordsForDelete.length > 0) {
              this.deleteUploadedFile()
            } else {
              // console.log('this.setProlist == 1')
              this.getBannerList()
            }
          }
        } else {
          alert('내용 변경에 실패하였습니다.')
        }
      })
    },
    tranSaveVaild () {
      if (this.infoModal.bannerOrd === '') {
        return '순서 번호를 입력하세요.'
      }
      if (this.infoModal.bannerTitle === '') {
        return '배너 제목을 입력하세요.'
      }
      if (this.infoModal.bannerUrl === '') {
        return '배너 URL을 입력하세요.'
      }
      if (this.fileRecords.length === 0) {
        return '배너 이미지가 없습니다.'
      }
      return 'success'
    },
    resetInfoModal () {
      /* this.infoModal.title = ''
      this.infoModal.content = '' */
    },
    deleteItem (item, index) {
      const deleteConfirm = confirm('정말 삭제하시겠습니까??')
      if (deleteConfirm === true) {
        const params = {
          'bannerTitle': item.banTitle,
          'bannerDesc': item.banDesc,
          'bannerUrl': item.banUrl,
          'bannerOrd': item.banOrd,
          'bannerNo': item.banId,
          'typeSelected': item.itemCd,
          'viewSelected': item.banView
        }
        this.saveBanner('D', params)
      } else {
        return false
      }
    },
    itemFilter () {
      // alert('itemFilter')
      this.getBannerList()
    },
    allItemFilter () {
      alert('allItemFilter')
    },
    modalAdd () {
      let str = this.tranSaveVaild()
      if (str === 'success') {
        this.saveBanner('I', this.infoModal)
      } else {
        alert(str)
      }
      /* alert('modalAdd')
      this.$nextTick(() => {
        this.$bvModal.hide('add-banner')
      }) */
    },
    modifySave () {
      let str = this.tranSaveVaild()
      if (str === 'success') {
        this.saveBanner('U', this.infoModal)
      } else {
        alert(str)
      }
      /* alert('modifySave')
      this.$nextTick(() => {
        this.$bvModal.hide('modify-banner')
      }) */
    },
    modalSave () {
      alert('modalSave')
      this.$nextTick(() => {
        this.$bvModal.hide('add-banner')
      })
    },
    resetModal () {
      // alert('resetModal')
    },
    getFileInfo (item) {
      let obj = []
      if (item.fileName === '') {
        return obj
      } else {
        let fileArr = item.fileName.split('/')
        let file = {
          name: fileArr[fileArr.length - 1],
          file: { name: fileArr[fileArr.length - 1] },
          url: this.imgUrl + '/' + item.fileName,
          lastModified: item.fileLast,
          size: item.fileSize,
          type: item.fileType,
          ext: item.fileExt
        }
        obj.push(file)
        return obj
      }
    },
    filesSelected: function (fileRecordsNewlySelected) {
      // console.log('filesSelected = ' + JSON.stringify(fileRecordsNewlySelected))
      var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error)
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords)
      if (this.fileRecordsForUpload.length > 1) {
        var tmpFileRecord = this.fileRecordsForUpload[0]
        // console.log('filesSelected fileRecords tmp=' + JSON.stringify(tmpFileRecord))
        this.onBeforeDelete(tmpFileRecord)
      }
      // console.log('filesSelected fileRecords =' + JSON.stringify(this.fileRecords))
      // console.log('filesSelected fileRecordsForUpload =' + JSON.stringify(this.fileRecordsForUpload))
    },
    fileDeleted: function (fileRecord) {
      // console.log('fileDeleted = ' + JSON.stringify(fileRecord))
      var i = this.fileRecordsForUpload.indexOf(fileRecord)
      // console.log('fileDeleted i = ' + i)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      }
      /* else {
        this.deleteUploadedFile(fileRecord)
      } */
    },
    deleteUploadedFile: function () {
      // console.log('deleteUploadedFile = ' + JSON.stringify(this.fileRecordsForDelete))
      const params = {
        'deleteFiles': this.fileRecordsForDelete,
        'gubun': '04',
        'idDtFile': this.tranBannerRtn.banId
      }
      this.$store.dispatch('apiDeleteFiles', params).then(() => {
        if (this.deleteFilesRtn !== 'ok') {
          alert('file을 삭제 중 이상이 발생하였습니다.')
        } else {
          this.uploadFiles()
        }
      })
    },
    onBeforeDelete: function (fileRecord) {
      // fileRecord.name = fileRecord.file.name
      // console.log('onBeforeDelete = ' + JSON.stringify(fileRecord))
      // console.log('onBeforeDelete = ' + JSON.stringify(this.fileRecordsForUpload))
      var i = this.fileRecordsForUpload.indexOf(fileRecord)
      // console.log('onBeforeDelete = ' + i)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
        var k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
        // console.log(JSON.stringify(fileRecord))
        // console.log(JSON.stringify(fileRecord.url))
        let idx = JSON.stringify(fileRecord).indexOf(this.imgUrl)
        if (idx !== -1) {
          this.fileRecordsForDelete.push(fileRecord)
        }
      } else {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord)
      }
    },
    uploadFiles: function () {
      // console.log('uploadFiles = ' + this.fileRecordsForUpload.length)
      let tranBannerRtn = this.tranBannerRtn.banId
      // console.log('tranBannerRtn = ' + tranBannerRtn)
      if (this.fileRecordsForUpload.length > 0) {
        // console.log('uploadFiles = ' + JSON.stringify(this.fileRecordsForUpload))
        this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload, function createFormData (fileData) {
          var formData = new FormData()
          formData.append('id', tranBannerRtn)
          formData.append('type', '04')
          formData.append('file', fileData.file)
          return formData
        }).then(response => {
          // console.log('response = ' + response.state)
          // console.log('uploadFiles = 22')
          this.fileDataUpload()
        })
        // console.log('uploadFiles = 11')
      } else {
        const params = {
          'Gubun': '04',
          'idAtFile': this.tranBannerRtn.banId,
          'flag': 'DELETE'
        }
        // console.log(params)
        this.$store.dispatch('apiAttachedFiles', params).then(() => {
          // console.log('response = ' + response)
          if (this.fileFlag === 'ok') {
            this.fileRecordsForUpload = []
            this.fileRecordsForDelete = []
            this.fileRecords = []
            // console.log('this.getDocumentList == 3')
            this.getBannerList()
          }
        })
      }
    },
    fileDataUpload () {
      /* console.log('onUpload = ' + JSON.stringify(this.fileRecordsForUpload))
      console.log('type = ' + this.fileRecordsForUpload[0].type)
      console.log('size = ' + this.fileRecordsForUpload[0].size)
      console.log('ext = ' + this.fileRecordsForUpload[0].ext)
      console.log('lastModified = ' + this.fileRecordsForUpload[0].lastModified)
      console.log('lastModified = ' + this.fileRecordsForUpload[0].file.name) */
      this.AtFile = []
      this.AtFile.push({'nameAtFile': this.fileRecordsForUpload[0].file.name, 'ordAtFile': 0, 'fileType': this.fileRecordsForUpload[0].type, 'fileSize': this.fileRecordsForUpload[0].size, 'fileExt': this.fileRecordsForUpload[0].ext, 'fileMody': this.fileRecordsForUpload[0].lastModified})
      const params = {
        'Gubun': '04',
        'idAtFile': this.tranBannerRtn.banId,
        'AtFile': this.AtFile,
        'flag': 'INSERT'
      }
      // console.log(params)
      this.$store.dispatch('apiAttachedFiles', params).then(() => {
        // console.log('response = ' + response)
        if (this.fileFlag === 'ok') {
          this.fileRecordsForUpload = []
          this.fileRecordsForDelete = []
          this.fileRecords = []
          // console.log('this.getDocumentList == 3')
          this.getBannerList()
        }
      })
    },
    onUpload (responses) {
      // console.log('onUpload = ' + JSON.stringify(responses))
    },
    onUploadError (failedResponses) {
      alert('file 업로드 중 이상이 발생하였습니다.')
      // console.log('ERROR : ', failedResponses)
    }
  },
  computed: {
    ...mapGetters({
      typeBanner: 'getEtcCode001List',
      typeViewFrame: 'getEtcCode002List',
      items: 'getBannerList',
      tranBannerRtn: 'getTranBanner',
      deleteFilesRtn: 'getDeleteFiles',
      fileFlag: 'getAttachedFlag'
    })
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/admin/AdminBanner.vue